export const GiftData = [
  {
    id:"1",
    GiftCard: "GFT1110",
    Customer: "Carl Evans",
    IssuedDate: "24 Dec 2024",
    ExpiryDate: "24 Jan 2025",
    Amount: "$200",
    Balance: "$100",
    Status: "Active",
    Image:"user-33.png"
  },
  {
    id:"2",
    GiftCard: "GFT1109",
    Customer: "Minerva Rameriz",
    IssuedDate: "10 Dec 2024",
    ExpiryDate: "10 Jan 2025",
    Amount: "$300",
    Balance: "$200",
    Status: "Active",
    Image:"user-02.jpg"
  },
  {
    id:"3",
    GiftCard: "GFT1108",
    Customer: "Robert Lamon",
    IssuedDate: "27 Nov 2024",
    ExpiryDate: "27 Dec 2024",
    Amount: "$200",
    Balance: "$150",
    Status: "Active",
    Image:"user-34.jpg"
  },
  {
    id:"4",
    GiftCard: "GFT1107",
    Customer: "Patricia Lewis",
    IssuedDate: "18 Nov 2024",
    ExpiryDate: "18 Dec 2024",
    Amount: "$120",
    Balance: "$0",
    Status: "Redeemed",
    Image:"user-35.jpg"
  },
  {
    id:"5",
    GiftCard: "GFT1106",
    Customer: "Mark Joslyn",
    IssuedDate: "06 Nov 2024",
    ExpiryDate: "06 Dec 2024",
    Amount: "$350",
    Balance: "$300",
    Status: "Active",
    Image:"user-36.jpg"
  },
  {
    id:"6",
    GiftCard: "GFT1105",
    Customer: "Marsha Betts",
    IssuedDate: "25 Oct 2024",
    ExpiryDate: "25 Nov 2024",
    Amount: "$500",
    Balance: "$400",
    Status: "Active",
    Image:"user-37.jpg"
  },
  {
    id:"7",
    GiftCard: "GFT1104",
    Customer: "Daniel Jude",
    IssuedDate: "14 Oct 2024",
    ExpiryDate: "14 Nov 2024",
    Amount: "$220",
    Balance: "$150",
    Status: "Active",
    Image:"user-28.jpg"
  },
  {
    id:"8",
    GiftCard: "GFT1103",
    Customer: "Emma Bates",
    IssuedDate: "03 Oct 2024",
    ExpiryDate: "03 Nov 2024",
    Amount: "$260",
    Balance: "$220",
    Status: "Inactive",
    Image:"user-38.jpg"
  },
  {
    id:"9",
    GiftCard: "GFT1102",
    Customer: "Richard Fralick",
    IssuedDate: "20 Sep 2024",
    ExpiryDate: "20 Oct 2024",
    Amount: "$200",
    Balance: "$160",
    Status: "Active",
    Image:"user-39.jpg"
  },
  {
    id:"10",
    GiftCard: "GFT1101",
    Customer: "Michelle Robison",
    IssuedDate: "10 Sep 2024",
    ExpiryDate: "10 Oct 2024",
    Amount: "$400",
    Balance: "$350",
    Status: "Expired",
    Image:"user-40.jpg"
  },
];
